import handleSectionsPage from './sections';
import handleAdminPage from "./admin";
import handleLibraryPage from './library';
import handleCollectiveDownloadPage from './collectiveDownloadVew'


export default function handlePage(path) {
    // handle admin routes separately
    if(~path.indexOf('/admin')) {
        handleAdminPage(path);
        return;
    }

    if(~path.indexOf('/report') && !~path.indexOf('/file')) {
        handleSectionsPage(path);
        return;
    }

    if (~path.indexOf('/library/collective-download')) {
        handleCollectiveDownloadPage();
        return;
    }

    if(~path.indexOf('/library')) {
        handleLibraryPage();
        return;
    }
};


